import { persianToEnglishDigits } from "./fa2en";

// src/utils/dateUtils.js
export function calculateDateDiff(service) {
    let min=0, max=0, now=0
    if (service.remainUnit === 'km') {
        min = service.lastKm4Edit
        now = service.programKm4Edit - persianToEnglishDigits(service.remain)
        max = service.programKm4Edit
      } else {
        const date1 = new Date(service.lastDateG);
        const date2 = new Date(service.programDateG);  
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        min= 0
        max= diffDays
        now= diffDays - persianToEnglishDigits(service.remain)
      }
    return {
      min,
      max,
      now
    };
  }
  